<template>
	<contentBox v-if="!loadError" v-bind:loading="!recLoaded">
		<contentTitle v-if="communityPlan" label="COMMUNITY PLAN" close="home">
			<h2 class="text-white font-weight-light pb-2">{{communityPlan.name}}</h2>
		</contentTitle>
		<contentBody v-if="communityPlan">
			<contentActions v-if="communityPlan">
				<button class="btn btn-outline-light btn-sm" v-bind:class="{active:shareShown === true}" v-on:click="share">
					<i class="material-icons md-18" title="share community plan">share</i> 
					Share
				</button>
				<button class="btn btn-outline-light btn-sm" v-on:click="zoomTo">
					<i class="material-icons md-18" title="center map on community plan">place</i> 
					Center
				</button>
				<button v-if="isAdmin" class="btn btn-outline-light btn-sm" v-on:click="edit">
					<i class="material-icons md-18" title="edit community plan">edit</i> 
					Edit
				</button>
			</contentActions>
			<share v-if="shareShown" v-bind:link="location" @close="share"></share>
			<div class="p-3">
				<div class="category-body">
					<div v-if="communityPlan.description !== null" class="category">
						<div class="category-title">DESCRIPTION</div>
						<div v-if="descriptionExpanded" class="property-row">
							<div class="text-description">{{description}}</div>
							<div v-if="description !== descriptionShort">
								<a href="javascript:" v-on:click="descriptionLess">less</a>
							</div>
						</div>
						<div v-else class="property-row">
							<div class="text-description">{{descriptionShort}}</div>
							<div v-if="description !== descriptionShort">
								<a href="javascript:" v-on:click="descriptionMore">more</a>
							</div>
						</div>
					</div>
					<div v-if="communityPlan.jurisdiction !== null && communityPlan.jurisdiction.name !== null" class="category">
						<div class="category-title">JURISDICTION</div>
						<div class="property-row">
							<div class="text-description property-locked">{{communityPlan.jurisdiction.name}}</div>
						</div>
					</div>
					<div v-if="communityPlan.references" class="category">
						<div class="category-title">REFERENCES</div>
						<div v-for="(ref, idx) in communityPlan.references" class="property-row">
							<label>{{ref.description}}</label>
							<div class="property-value-right">
								<a :href="ref.url" target="_blank"><i class="material-icons md-12">open_in_new</i> Link</a>
							</div>
						</div>
					</div>
					<div v-if="!description && !communityPlan.references" class="category">
						<div class="category-title">DETAILS</div>
						<div class="property-row">
							<div class="text-description">No data available for this community plan</div>
						</div>
					</div>
				</div>
			</div>
		</contentBody>
	</contentBox>

</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import share from '../share/share';

export default {
	name: 'community-plan',

	props:{
		id: Number
	},

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		share
	},

	beforeDestroy: function(){
		this.$store.dispatch('COMMUNITY_PLAN_HIGHLIGHT_CLEAR',{});
	},

	computed: {
		isAdmin: function(){
			return this.$store.state.agent.rec && this.$store.state.agent.rec.role.name && this.$store.state.agent.rec.role.name === 'admin';
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		communityPlan: function() {
			return this.$store.state.communityPlan.rec;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		description:function(){
			return this.communityPlan.description;
		},
		descriptionShort:function(){
			if (this.description.length > 500) return this.description.substr(0,500)+'...';
			return this.description;
		},
		location:function(){
			return window.location.href;
		},
		zoomToDone:function(){
			return this.$store.state.map.fitBoundsDone;
		}
	},
	created: function(){
		this.getRec();
	},
	data: function(){
		return {
			descriptionExpanded:false,
			recLoaded:false,
			shareShown:false,
			loadError:null
		}
	},
	methods: {
		edit:function(){
			this.$router.push({
				name: 'community-plan-edit',
				params:{
					id: this.$route.params.id
				}
			});
		},
		getRec: function(){
			this.recLoaded = false;
			this.loadError = null;
			this.$store.dispatch('COMMUNITY_PLAN_GET', {
				id: this.id
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		routeClose:function(){
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		highlight:function(){
			this.$store.dispatch('COMMUNITY_PLAN_HIGHLIGHT',{});
		},
		zoomTo:function(){
			this.$store.dispatch('COMMUNITY_PLAN_ZOOM_TO',{});
		},
		checkInside:function(){
			const bbox = this.communityPlan.bounds.bbox;
			const bounds = this.mapBounds;

			if (this.mapZoom >= 13 || this.mapZoom <= 10) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.communityPlan || !this.recLoaded || !this.mapLoaded) return;
			this.ready();
		},
		ready:function(){
			if (!this.checkInside()) this.zoomTo();
			else this.highlight();
			this.updateTitleTag();
		},
		updateTitleTag:function(){
			document.title = this.communityPlan.name+' - Scoutred Maps';
		},
		descriptionLess:function(){
			this.descriptionExpanded = false;
		},
		descriptionMore:function(){
			this.descriptionExpanded = true;
		},
		share:function(){
			if (this.shareShown){
				this.shareShown = false;
				return;
			}
			if (navigator.share){
				navigator.share({
				  title: this.communityPlan.name+' - Scoutred Maps',
				  text: 'Community plan data for '+this.communityPlan.name,
				  url: window.location.href,
				});
				return;
			}

			this.shareShown = true;
		}
	},
	watch: {
		id:function(newId, oldId){
			if (newId === oldId) return;
			this.getRec();
		},
		communityPlan:function(toRec, fromRec){
			if (toRec) this.recLoaded = true;
			this.checkReady();
		},
		mapLoaded:function(){
			this.checkReady();
		},
		zoomToDone:function(){
			this.highlight();
		}
	},
}

</script>



// WEBPACK FOOTER //
// src/components/community-plan/community-plan.vue